export default {
  publicExam_pass_score:'及格',
  publicExam_number_participants:'已参与人数',
  publicExam_total_score:"满分{totalScoreStr}",
  publicExam_min_score:'及格{minScoreStr}',
  publicExam_totalTestNum:'已参与人数{totalTestNum}',
  publicExam_current_tab:'还没有{currentTab}'
}

